import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-asset-icon',
  template: `
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_26583_11932)">
        <path
          d="M21.2054 17.4001L18.377 20.2285L26.3719 28.2235L29.2003 25.3951L21.2054 17.4001Z"
          fill="white"
        />
        <path
          d="M23.3341 13.3324C25.9074 13.3324 28.0008 11.2391 28.0008 8.66575C28.0008 7.89242 27.7874 7.17242 27.4541 6.53242L23.8541 10.1324L21.8674 8.14576L25.4674 4.54576C24.8274 4.21242 24.1074 3.99909 23.3341 3.99909C20.7608 3.99909 18.6674 6.09242 18.6674 8.66575C18.6674 9.21242 18.7741 9.73242 18.9474 10.2124L16.4808 12.6791L14.1074 10.3058L15.0541 9.35909L13.1741 7.47909L16.0008 4.65242C14.4408 3.09242 11.9074 3.09242 10.3474 4.65242L5.62745 9.37242L7.50745 11.2524H3.74745L2.80078 12.1991L7.52078 16.9191L8.46745 15.9724V12.1991L10.3474 14.0791L11.2941 13.1324L13.6674 15.5058L3.78745 25.3858L6.61411 28.2124L21.7874 13.0524C22.2674 13.2258 22.7874 13.3324 23.3341 13.3324Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_26583_11932">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetIconComponent {}
